import React, {useState} from "react";
import {Box, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {Card, TextField} from "@mui/material";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "start",
        width: "95%",
        height: "90%",
        padding: theme.spacing(4),
        borderRadius: "8px",
        backgroundColor: "#ffffff",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
        textAlign: "left",
        margin: "auto",
        overflow: "hidden",
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
            flexDirection: "column",
        },
    },
    title: {
        fontSize: "41px",
        fontWeight: "bold",
        marginBottom: theme.spacing(3),
        color: "#ED6628",
        lineHeight:'1.3',
        textAlign: 'left !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "34px",
        },
    },
    contentBox: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        flexGrow: 1,
        marginLeft: '15px',
        textAlign: "left",
        overflow: "visible",
    },
    rowContentBox: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        flexGrow: 1,
        gap: '11px',
        textAlign: "left",
        // flexWrap: "wrap",
        [theme.breakpoints.down('sm')]: {
            flexDirection: "column",
        },
    },
    textContent: {
        flex: 1,
        minWidth: 0,
    },
    list: {
        listStyleType: "none",
        paddingLeft: 0,
        margin: 0,
        width: "100%",
    },
    listItem: {
        fontSize: "clamp(16px, 2vw, 21px)",
        color: "#000000",
        marginBottom: "10px",
        lineHeight: "1.5",
        [theme.breakpoints.down('sm')]: {
            fontSize: "20px",
        },
    },
    pointTitle: {
        fontSize: "23px",
        fontWeight: "bold",
        color: "#000000",
        marginRight: "10px",
        [theme.breakpoints.down('sm')]: {
            fontSize: "19px",
        },
    },
    imageContainer: {
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxHeight: "72%",
    },
    image: {
        maxWidth: "100%",
        maxHeight: "100%",
        borderRadius: "8px",
        objectFit: "contain",
    },
    questionTitle: {
        fontSize: "39px",
        fontWeight: "bold",
        lineHeight: '1.1',
        marginBottom: theme.spacing(3),
        color: "#ED6628",
        [theme.breakpoints.down('sm')]: {
            fontSize: "31px",
        },
    },
    descriptionText: {
        fontSize: "24px",
        color: "#333",
        textAlign: "left",
        lineHeight: "1.5",
        [theme.breakpoints.down('sm')]: {
            fontSize: "21px",
        },
    },
    leftColumn: {
        flex: 1,
        minWidth: 0,
    },
    rightColumn: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));

//  Layout: INTRODUCTION_TITLE_WITH_GOALS
const IntroductionTitleWithGoals = ({title, slideContent}) => {
    const classes = useStyles();
    let contentArray = [];
    if (Array.isArray(slideContent)) {
        if (slideContent.length === 1 && typeof slideContent[0] === 'string') {
            // Case: slideContent is a single string inside an array
            contentArray = [{PointTitle: "", PointText: slideContent[0]}];
        } else {
            // Case: slideContent is an array of objects
            contentArray = slideContent;
        }
    } else if (typeof slideContent === "string") {
        // Case: slideContent is a plain string
        contentArray = [{PointTitle: "", PointText: slideContent}];
    }
    return (
        <Box className={classes.container} style={{
            minHeight: "auto",
            flexDirection: "column",
            alignItems: "flex-start"
        }}>
            <Typography className={classes.title}>{title}</Typography>
            <Box className={classes.contentBox} style={{marginLeft: '0px'}}>
                <ul className={classes.list}>
                    {contentArray.map((item, index) => (
                        <li key={index} className={classes.listItem}>
                            {item.PointTitle &&
                                <strong className={classes.pointTitle}>{item.PointTitle}:</strong>} {item.PointText}
                        </li>
                    ))}
                </ul>
            </Box>
        </Box>
    );
};

//  Layout: CONTENT_3_POINTS_WITH_NO_IMAGE
const Content3PointsWithNoImage = ({title, slideContent}) => {
    const classes = useStyles();
    return (
        <Box className={classes.container} style={{minHeight: "auto"}}>
            <Typography className={classes.title}>{title}</Typography>
            <Box className={classes.contentBox}>
                <ul className={classes.list}>
                    {slideContent.map((item, index) => (
                        <li key={index} className={classes.listItem}>
                            <strong className={classes.pointTitle}>{item.PointTitle}:</strong> {item.PointText}
                        </li>
                    ))}
                </ul>
            </Box>
        </Box>
    );
};

//  Layout: CONTENT_4_POINTS_WITH_NO_IMAGE
const Content4PointsWithNoImage = ({title, slideContent}) => {
    const classes = useStyles();
    return (
        <Box className={classes.container} style={{minHeight: "auto"}}>
            <Typography className={classes.title}>{title}</Typography>
            <Box className={classes.contentBox}>
                <ul className={classes.list}>
                    {slideContent.map((item, index) => (
                        <li key={index} className={classes.listItem}>
                            <strong className={classes.pointTitle}>{item.PointTitle}:</strong> {item.PointText}
                        </li>
                    ))}
                </ul>
            </Box>
        </Box>
    );
};

//  Layout: CONTENT_2_POINTS_WITH_1_IMAGE
const Content2PointsWith1Image = ({title, slideContent, images}) => {
    const classes = useStyles();
    return (
        <Box className={classes.container}>
            <Box className={classes.rowContentBox}>
                <Box className={classes.leftColumn}>
                    <Typography className={classes.title}>{title}</Typography>
                    <ul className={classes.list}>
                        {slideContent.map((item, index) => (
                            <li key={index} className={classes.listItem}>
                                <strong className={classes.pointTitle}>{item.PointTitle}:</strong> {item.PointText}
                            </li>
                        ))}
                    </ul>
                </Box>
                {images.length > 0 && (
                    <Box className={classes.rightColumn}>
                        <img src={images[0]} alt="Slide" className={classes.image}/>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

//  Layout: CONTENT_3_POINTS_WITH_1_IMAGE
const Content3PointsWith1Image = ({title, slideContent, images}) => {
    const classes = useStyles();
    return (
        <Box className={classes.container}>
            <Box className={classes.rowContentBox}>
                <Box className={classes.leftColumn}>
                    <Typography className={classes.title}>{title}</Typography>
                    <ul className={classes.list}>
                        {slideContent.map((item, index) => (
                            <li key={index} className={classes.listItem}>
                                <strong className={classes.pointTitle}>{item.PointTitle}:</strong> {item.PointText}
                            </li>
                        ))}
                    </ul>
                </Box>
                {images.length > 0 && (
                    <Box className={classes.rightColumn}>
                        <img src={images[0]} alt="Slide" className={classes.image}/>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

//  Layout: CONTENT_SINGLE_POINT_WITH_1_IMAGE
const ContentSinglePointWith1Image = ({title, slideContent, images}) => {
    const classes = useStyles();
    let contentItem = {PointTitle: "", PointText: ""};
    if (Array.isArray(slideContent)) {
        if (slideContent.length === 1 && typeof slideContent[0] === "string") {
            // Case: slideContent is a single string inside an array
            contentItem = {PointTitle: "", PointText: slideContent[0]};
        } else if (slideContent.length > 0 && typeof slideContent[0] === "object") {
            // Case: slideContent is an array of objects
            contentItem = slideContent[0];
        }
    } else if (typeof slideContent === "string") {
        // Case: slideContent is a plain string
        contentItem = {PointTitle: "", PointText: slideContent};
    }
    return (
        <Box className={classes.container}>
            <Box className={classes.rowContentBox}>
                <Box className={classes.leftColumn}>
                    <Typography className={classes.title}>{title}</Typography>
                    <Typography className={classes.descriptionText}>
                        {contentItem.PointTitle &&
                            <strong className={classes.pointTitle}>{contentItem.PointTitle}: </strong>}
                        {contentItem.PointText}
                    </Typography>
                </Box>
                {images.length > 0 && (
                    <Box className={classes.rightColumn}>
                        <img src={images[0]} alt="Slide" className={classes.image}/>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

//  Layout: CONTENT_DESCRIPTION_WITH_NO_IMAGE
const ContentDescriptionWithNoImage = ({title, slideContent}) => {
    const classes = useStyles();

    return (
        <Box className={classes.container} style={{minHeight: "auto"}}>
            <Typography className={classes.title}>{title}</Typography>
            <Box className={classes.contentBox}>
                <Typography className={classes.descriptionText}>
                    {slideContent}
                </Typography>
            </Box>
        </Box>
    );
};

//  Layout: FINAL_SUMMARY
const FinalSummary = ({title, slideContent}) => {
    const classes = useStyles();
    return (
        <Box className={classes.container} style={{minHeight: "auto"}}>
            <Typography className={classes.title}>{title}</Typography>
            <Box className={classes.contentBox}>
                <Typography className={classes.descriptionText}>
                    {slideContent}
                </Typography>
            </Box>
        </Box>
    );
};

//Assessment Slide
// const Assessment = ({questions}) => {
//     const [answers, setAnswers] = useState({});
//     const classes = useStyles();
//
//     const handleOptionSelect = (questionId, optionId) => {
//         setAnswers({...answers, [questionId]: optionId});
//     };
//
//     const handleMultiSelectChange = (questionId, optionId) => {
//         const selectedOptions = answers[questionId] || [];
//         setAnswers({
//             ...answers,
//             [questionId]: selectedOptions.includes(optionId)
//                 ? selectedOptions.filter((opt) => opt !== optionId)
//                 : [...selectedOptions, optionId],
//         });
//     };
//
//     const handleAnswerChange = (questionId, value) => {
//         setAnswers({...answers, [questionId]: value});
//     };
//
//     const renderQuestion = (question) => {
//         switch (question.AssessmentType) {
//             case "MCQ":
//             case "TF":
//                 return (
//                     <Box>
//                         {question.AnswerOptions.map((option) => (
//                             <Card
//                                 key={option.OptionID}
//                                 onClick={() => handleOptionSelect(question.AssessmentID, option.OptionID)}
//                                 sx={{
//                                     marginBottom: 2,
//                                     padding: 2,
//                                     cursor: "pointer",
//                                     backgroundColor: answers[question.AssessmentID] === option.OptionID
//                                         ? "#F17632"
//                                         : "#f5f5f5",
//                                     color: answers[question.AssessmentID] === option.OptionID
//                                         ? "#fff"
//                                         : "#5A5A5A",
//                                     borderRadius: "10px",
//                                     transition: "0.3s",
//                                     '&:hover': {
//                                         transform: 'scale(1.01)',
//                                         boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                                     },
//                                     '& .MuiTypography-root': {
//                                         fontSize: '24px'
//                                     }
//                                 }}
//                             >
//                                 <Typography style={{fontSize: "18px",}}>{option.OptionText}</Typography>
//                             </Card>
//                         ))}
//                     </Box>
//                 );
//
//             case "MAQ":
//                 return (
//                     <Box>
//                         {question.AnswerOptions.map((option) => (
//                             <Card
//                                 key={option.OptionID}
//                                 onClick={() => handleMultiSelectChange(question.AssessmentID, option.OptionID)}
//                                 sx={{
//                                     marginBottom: 2,
//                                     padding: 2,
//                                     cursor: "pointer",
//                                     backgroundColor: answers[question.AssessmentID]?.includes(option.OptionID)
//                                         ? "#F17632"
//                                         : "#f5f5f5",
//                                     color: answers[question.AssessmentID]?.includes(option.OptionID)
//                                         ? "#fff"
//                                         : "#5A5A5A",
//                                     borderRadius: "10px",
//                                     transition: "0.3s",
//                                     '&:hover': {
//                                         transform: 'scale(1.01)',
//                                         boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                                     }
//                                 }}
//                             >
//                                 <Typography style={{fontSize: "18px"}}>{option.OptionText}</Typography>
//                             </Card>
//                         ))}
//                     </Box>
//                 );
//
//             case "Theory":
//                 return (
//                     <TextField
//                         fullWidth
//                         variant="outlined"
//                         multiline
//                         rows={4}
//                         placeholder="Write your answer here..."
//                         value={answers[question.AssessmentID] || ""}
//                         onChange={(e) => handleAnswerChange(question.AssessmentID, e.target.value)}
//                         sx={{
//                             '& .MuiOutlinedInput-root': {
//                                 '& fieldset': {
//                                     borderColor: '#ddd',
//                                 },
//                                 '&:hover fieldset': {
//                                     borderColor: '#F17632',
//                                 },
//                             }
//                         }}
//                     />
//                 );
//
//             default:
//                 return <Typography>No question available</Typography>;
//         }
//     };
//
//     return (
//         <Box className={classes.container} style={{minHeight: "auto"}}>
//             {questions.map((question, index) => (
//                 <Box key={index} width="100%">
//                     <Typography className={classes.questionTitle}>{question.AssessmentQuestion}</Typography>
//                     {renderQuestion(question)}
//                 </Box>
//             ))}
//         </Box>
//     );
// };


export {
    IntroductionTitleWithGoals,
    Content3PointsWithNoImage,
    Content4PointsWithNoImage,
    Content2PointsWith1Image,
    Content3PointsWith1Image,
    ContentSinglePointWith1Image,
    ContentDescriptionWithNoImage,
    FinalSummary,
    // Assessment
};